import React from 'react'
import { Helmet } from 'react-helmet'
import { Container } from 'react-bootstrap'
import { Row, Col, Pagination } from 'antd'
import Slider from 'react-slick'
import qs from 'query-string'
import Helper from 'utils/Helper'

const InfoBerita = ({
  data,
  categories,
  setCurrentPage,
  getList,
  pengumuman,
  clickHelpCenter,
}) => {
  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    initialSlide: 0,
  }

  const handleChange = (page) => {
    setCurrentPage(page)
    const payload = {
      page: page,
      limit: 6,
      status: 'active',
    }
    const cleanedPayload = Helper.cleanObject(payload)
    getList(`?${qs.stringify(cleanedPayload)}`)
  }

  const handleClickHelpCenter = () => {
    clickHelpCenter()
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Info & Berita | Situs Informasi SIPLah</title>
        <link rel="canonical" href="siplah.kemendikdasmen.go.id/info-berita" />
        <meta http-equiv="Cache-control" content="max-age=31536000"></meta>
        <meta
          name="title"
          content="Info & Berita | Situs Informasi SIPLah"
        ></meta>
        <meta
          name="description"
          content="Lihat pengumuman terbaru, regulasi, informasi, dan liputan tentang SIPLah."
        ></meta>
      </Helmet>
      <div className="h-100">
        <section className="bg-dark-blue text-white section-pertanyaan-umum">
          <Container>
            <h1 className="font-switzer-semibold text-white gap-text-header-44-32">
              <b>Info & Berita</b>
            </h1>
            <Row gutter={[16, 16]}>
              <Col lg={16} md={24} sm={24} xs={24}>
                <Slider {...settings} className="slider-berita m-b-50">
                  {data?.list
                    ?.filter((d) => d.slideshow == 1 && d.status === 'active')
                    .slice(0, 3)
                    .map((d, i) => (
                      <a
                        className="category-berita"
                        key={i}
                        href={`/info-berita/${d.id}/detail`}
                      >
                        <img
                          src={d.image_name}
                          alt="slideshow"
                          height="320px"
                          className="m-b-36 img-slider-berita img-block"
                        />
                        <div className="text-white-smoke m-b-16 font-size-14">
                          <b>
                            {d.published_at.split(' ')[0]}{' '}
                            {d.published_at.split(' ')[1]}{' '}
                            {d.published_at.split(' ')[2]} &#183;{' '}
                            {d.category?.name}
                          </b>
                        </div>
                        <div className="text-white font-size-36 m-b-16 title">
                          <b>{d.title}</b>
                        </div>
                        <div className="text-white font-size-20">
                          {d.excerpt.slice(0, 80)}
                        </div>
                      </a>
                    ))}
                </Slider>
              </Col>
              <Col lg={8} md={24} sm={24} xs={24}>
                {data?.list
                  ?.filter((d) => d.is_top == true && d.status === 'active')
                  .slice(0, 4)
                  .map((d, i) => (
                    <a
                      className="category-berita m-t-12"
                      key={i}
                      href={`/info-berita/${d.id}/detail`}
                    >
                      <div className="font-size-14 text-white-smoke m-b-16 text-uppercase">
                        <b>
                          {d.published_at.split(' ')[0]}{' '}
                          {d.published_at.split(' ')[1]}{' '}
                          {d.published_at.split(' ')[2]} &#183;{' '}
                          {d.category?.name}
                        </b>
                      </div>
                      <Row gutter={[16, 16]}>
                        <Col lg={16} md={16} sm={16} xs={16}>
                          <div className="font-size-19 text-white m-b-24 title">
                            <b>{d.title}</b>
                          </div>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={8}>
                          <img
                            src={d.image_name}
                            alt="berita"
                            className="img-border-radius-4"
                            style={{ maxHeight: '100px' }}
                          />
                        </Col>
                      </Row>
                      <hr className="text-white m-t-24 m-b-24" />
                    </a>
                  ))}
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section-head">
          <Container>
            <h2 className="font-switzer-semibold m-b-44">
              <b>Eksplorasi Berdasarkan Kategori</b>
            </h2>
            <Row gutter={[16, 16]}>
              {categories.length > 0 &&
                categories
                  ?.filter((d) => d.status === 'active')
                  .map((d, i) => (
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      xs={24}
                      className="p-l-0 p-r-0"
                      key={i}
                    >
                      <a
                        className={`category why-use-siplah ${
                          i == 0
                            ? 'box-1'
                            : i == 1
                            ? 'box-3'
                            : i ==
                              categories?.filter((d) => d.status === 'active')
                                .length -
                                2
                            ? 'box-4'
                            : i ==
                              categories?.filter((d) => d.status === 'active')
                                .length -
                                1
                            ? 'box-6'
                            : 'box-2'
                        }`}
                        href={`/info-berita/${d.id}`}
                      >
                        <Row gutter={[16, 16]}>
                          <Col lg={4} md={4} sm={4} xs={4}>
                            <img
                              src={d.logo_path}
                              alt="kategori"
                              className="img-category"
                            />
                          </Col>
                          <Col
                            lg={16}
                            md={16}
                            sm={16}
                            xs={16}
                            className="text-left"
                          >
                            <b className="m-b-8 font-size-17">{d.name}</b>
                            <div className="grey-text">{d.description}</div>
                          </Col>
                          <Col
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            className="text-right"
                          >
                            <span className="material-symbols-outlined">
                              arrow_forward
                            </span>
                          </Col>
                        </Row>
                      </a>
                    </Col>
                  ))}
            </Row>
          </Container>
        </section>
        <section>
          <Container>
            <Row
              gutter={[16, 16]}
              className="berita-text-container m-b-44 d-flex align-items-center"
            >
              <Col lg={16} md={16} sm={24} xs={24}>
                <h2 className="font-switzer-semibold">
                  <b>Pengumuman</b>
                </h2>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24} className="text-right-left">
                <a
                  className="category-arrow-black"
                  href="/info-berita/e1263f32-c56a-4122-b438-243753df6164"
                >
                  <b className="d-flex align-items-center justify-content-end">
                    Lihat semua
                    <div className="material-symbols-outlined m-l-16">
                      arrow_forward
                    </div>
                  </b>
                </a>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="bg-dark-blue">
          <Container className="align-items-center">
            <div className="position-relative berita-pengumuman">
              <Row gutter={[16, 16]}>
                {pengumuman?.length > 0 &&
                  pengumuman?.slice(0, 3).map((d, i) => (
                    <Col
                      lg={8}
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ minHeight: '100%' }}
                      className="m-b-24"
                      key={i}
                    >
                      <a
                        href={`/info-berita/${d.id}/detail`}
                        className="category-berita card card-no-border d-flex justify-space-between"
                        style={{ height: '100%' }}
                      >
                        <img
                          className="card-img-top"
                          src={d.image_name}
                          alt="Card image cap"
                        />
                        <div className="card-body">
                          <div className="font-size-14 primary-blue m-b-16">
                            <b>
                              {d.published_at.split(' ')[0]}{' '}
                              {d.published_at.split(' ')[1]}{' '}
                              {d.published_at.split(' ')[2]}
                            </b>
                          </div>
                          <div className="text-caption-header m-b-12 title">
                            <b>{d.title}</b>
                          </div>
                          <div className="grey-text m-b-12">
                            {d.excerpt.slice(0, 80)}
                          </div>
                          <div>
                            <hr className="m-b-16" />
                            <div className="category-arrow">
                              <b className="d-flex align-items-center">
                                Selengkapnya
                                <div className="material-symbols-outlined m-l-16 text-subgrey">
                                  arrow_forward
                                </div>
                              </b>
                            </div>
                          </div>
                        </div>
                      </a>
                    </Col>
                  ))}
              </Row>
            </div>
          </Container>
        </section>
        <section className="section-head">
          <Container>
            <h2 className="font-switzer-bold m-b-36">
              <b>Informasi Terbaru</b>
            </h2>
            <Row gutter={[16, 16]}>
              {data?.list
                ?.filter((d) => d.status === 'active')
                .map((d, i) => (
                  <Col
                    lg={8}
                    md={12}
                    sm={12}
                    xs={24}
                    key={i}
                    style={{ minHeight: '100%' }}
                    className="m-b-24 p-l-12 p-r-12"
                  >
                    <a
                      href={`/info-berita/${d.id}/detail`}
                      className="category-berita card d-flex justify-space-between"
                      style={{ height: '100%' }}
                    >
                      <img
                        className="card-img-top"
                        src={d.image_name}
                        alt="Card image cap"
                      />
                      <div className="card-body">
                        <div className="font-size-14 primary-blue m-b-16 text-uppercase">
                          <b>
                            {d.published_at.split(' ')[0]}{' '}
                            {d.published_at.split(' ')[1]}{' '}
                            {d.published_at.split(' ')[2]} &#183;{' '}
                            {d.category?.name}
                          </b>
                        </div>
                        <div className="text-caption-header m-b-12 title">
                          <b>{d.title}</b>
                        </div>
                        <div className="grey-text m-b-12">
                          {d.excerpt.slice(0, 80)}
                        </div>
                        <div>
                          <hr className="m-b-16" />
                          <div className="category-arrow font-size-14">
                            <b className="d-flex align-items-center">
                              Selengkapnya
                              <div className="material-symbols-outlined m-l-16 text-subgrey">
                                arrow_forward
                              </div>
                            </b>
                          </div>
                        </div>
                      </div>
                    </a>
                  </Col>
                ))}
            </Row>
            <div className="text-center m-t-44 position-relative">
              <Pagination
                pageSize={data?.meta?.limit || 6}
                current={data?.meta?.page || 1}
                total={data?.meta?.total}
                onChange={(page) => handleChange(page)}
              />
            </div>
          </Container>
        </section>
        <section className="bg-white-smoke m-t-20">
          <Container className="container-bantuan-kami">
            <Row gutter={[16, 16]} className="align-items-center">
              <Col lg={13} md={15} sm={24} xs={24}>
                <h2 className="font-switzer-reguler gap-text-64-24">
                  <b>SIPLah siap membantu dan memandu Anda</b>
                </h2>
                <div className="font-size-20 m-b-32">
                Jika Anda memiliki pertanyaan atau mencari informasi terkait penggunaan SIPLah, Anda dapat mengunjungi Pusat Bantuan dan mencari topik yang dibutuhkan.
                </div>
                <a
                  href="https://pusatinformasi.siplah.kemendikdasmen.go.id/hc/en-gb"
                  target="_blank"
                  className="button-hubungi-kami gap-button-hubungi-kami"
                  onClick={() => handleClickHelpCenter()}
                >
                  <b>Kunjungi Pusat Bantuan</b>
                </a>
              </Col>
              <Col lg={1} md={1} sm={24} xs={24}></Col>
              <Col
                lg={10}
                md={8}
                sm={24}
                xs={24}
                className="d-none d-md-block bg-pusat-bantuan height-layanan"
                style={{
                  backgroundImage:
                    'url(./assets/homepage/img-siplah-info-berita.png)',
                }}
              ></Col>
            </Row>
          </Container>
        </section>
        <div className="display-flex overflow-x-hidden m-t-24">
          <span className="line-upper-footer bg-blue" />
          <span className="line-upper-footer bg-orange" />
          <span className="line-upper-footer bg-green" />
          <span className="line-upper-footer bg-pink" />
        </div>
      </div>
    </>
  )
}
export default InfoBerita
